import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'NewtworkUsageCard';

interface StylesProps {
  disabled: boolean;
  hasTooltip: boolean;
}

export const useNetworkUsageCardStyles = makeStyles<StylesProps>({ name })(
  (theme, { disabled, hasTooltip }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),

      padding: theme.spacing(4, 6),

      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadiusXl,

      [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(2),

        padding: theme.spacing(4),

        borderRadius: theme.shape.borderRadiusMd,
      },
    },
    title: {
      width: 'fit-content',

      borderBottom: hasTooltip
        ? `1px dashed ${alpha(theme.palette.link.main, 0.5)}`
        : undefined,

      color: disabled
        ? theme.palette.text.disabled
        : theme.palette.text.secondary,

      cursor: hasTooltip ? 'pointer' : undefined,
    },
    content: {
      color: disabled
        ? theme.palette.text.disabled
        : theme.palette.text.primary,
    },
    skeleton: {
      width: '100%',
      height: 22,

      transform: 'none',
    },
  }),
);
